import { useMemo } from 'react';
import useCombinedTranscriptions from '@shared/hooks/useCombinedTranscriptions';
import { CallActors } from '@shared/constants/recipient-status.constants';

export interface TestingConversationViewMessage {
  id: string;
  actor: string;
  message: string;
  createdAt: string;
  updatedAt: string;
}

export const useTestingConversationMessages = (): TestingConversationViewMessage[] => {
  const combinedTranscriptions = useCombinedTranscriptions();

  return useMemo(() => {
    return combinedTranscriptions.map((segment, index) => ({
      id: `live-${segment.id || index}`,
      actor: segment.role === 'assistant' ? CallActors.AGENT : CallActors.CUSTOMER,
      message: segment.text,
      createdAt: new Date(segment.firstReceivedTime).toISOString(),
      updatedAt: new Date(segment.firstReceivedTime).toISOString(),
    }));
  }, [combinedTranscriptions]);
};
